import { NumberField, TextField, SelectField, Form } from '@calendly/form';
import { Banner } from '@calendly/ui/components/banner';
import { BareButton } from '@calendly/ui/components/bare-button';
import { Button } from '@calendly/ui/components/button';
import { TextInput } from '@calendly/ui/components/text-input';
import classNames from 'classnames';
import { forwardRef } from 'react';
const panelBodyCss = "p1c1rfow";
export const PanelBody = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(panelBodyCss, props.className)} />;
});
const styledFormIsMobileCss = "smyxpo1";
const styledFormCss = "s1jyapxv";
export const StyledForm = forwardRef((props, ref) => {
  const {
    isMobile
  } = props;
  return <Form ref={ref} {...props} className={classNames(styledFormCss, {
    [styledFormIsMobileCss]: isMobile
  }, props.className)} />;
});
const formContainerCss = "fglegy7";
export const FormContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(formContainerCss, props.className)} />;
});
const fieldGroupCss = "f1fnhv5t";
export const FieldGroup = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(fieldGroupCss, props.className)} />;
});
const descriptionCss = "dqvfixg";
export const Description = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(descriptionCss, props.className)} />;
});
const typeToggleContainerCss = "te1raqt";
export const TypeToggleContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(typeToggleContainerCss, props.className)} />;
});
const typeButtonSelectedCss = "t1flar7d";
const typeButtonCss = "tvbdjlt";
export const TypeButton = forwardRef((props, ref) => {
  const {
    selected,
    ...restProps
  } = props;
  return <BareButton ref={ref} {...restProps} className={classNames(typeButtonCss, {
    [typeButtonSelectedCss]: selected
  }, props.className)} />;
});
const amountContainerIsInlineCss = "a178pc36";
const amountContainerCss = "a3kwzhs";
export const AmountContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    isInline,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(amountContainerCss, {
    [amountContainerIsInlineCss]: isInline
  }, props.className)} />;
});
const amountInputContainerCss = "ainn1k8";
export const AmountInputContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(amountInputContainerCss, props.className)} />;
});
const amountInputCss = "a1evokls";
export const AmountInput = forwardRef((props, ref) => {
  const {
    fixed: _fixed,
    ...restProps
  } = props;
  return <TextField ref={ref} spacingTop={0} spacingBottom={0} {...restProps} className={classNames(amountInputCss, props.className)} />;
});

/*
 * Composite currency chrome — mirrors CUI CurrencyInput: overflow:hidden clips the
 * nested input to the rounded border. FieldError must render outside this wrapper.
 */
const fixedAmountWrapperCss = "f1xgc7a1";
export const FixedAmountWrapper = forwardRef((props, ref) => <div ref={ref} {...props} className={classNames(fixedAmountWrapperCss, props.className)} />);
const fixedAmountContainerCss = "f1nzx20p";
export const FixedAmountContainer = forwardRef((props, ref) => <div ref={ref} {...props} className={classNames(fixedAmountContainerCss, props.className)} />);
const fixedAmountPrefixCss = "fbd4396";
export const FixedAmountPrefix = forwardRef((props, ref) => <div ref={ref} {...props} className={classNames(fixedAmountPrefixCss, props.className)} />);

// Match FormCurrencyField / CurrencyInput: composite wrapper owns the border;
// nested TextInput borders otherwise draw a second outline on focus.
// Uses TextInput (not TextField) so FieldError can render outside the overflow:hidden chrome.
const fixedAmountInputCss = "f127jr6k";
export const FixedAmountInput = forwardRef((props, ref) => <TextInput ref={ref} {...props} className={classNames(fixedAmountInputCss, props.className)} />);
const percentSymbolCss = "p1o2akxp";
export const PercentSymbol = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(percentSymbolCss, props.className)} />;
});
const currencyDisplayCss = "czv920p";
export const CurrencyDisplay = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(currencyDisplayCss, props.className)} />;
});
const currencySymbolCss = "c1o7yu17";
export const CurrencySymbol = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(currencySymbolCss, props.className)} />;
});
const currencyCodeCss = "c1wy5lnn";
export const CurrencyCode = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(currencyCodeCss, props.className)} />;
});
const usageLimitContainerIsInlineCss = "u1s4mlot";
const usageLimitContainerCss = "uwtctm4";
export const UsageLimitContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    isInline,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(usageLimitContainerCss, {
    [usageLimitContainerIsInlineCss]: isInline
  }, props.className)} />;
});
const usageLimitInputIsInlineCss = "ukg8df1";

// NumberField wraps its input in a fixed 80px container; override that container
// directly so the visible field width (not empty wrapper space) sits next to "time(s)".
const usageLimitInputCss = "u2uzlmw";
export const UsageLimitInput = forwardRef((props, ref) => {
  const {
    isInline,
    ...restProps
  } = props;
  return <NumberField ref={ref} spacingTop={0} spacingBottom={0} {...restProps} className={classNames(usageLimitInputCss, {
    [usageLimitInputIsInlineCss]: isInline
  }, props.className)} />;
});
const usageLimitTextCss = "usfn3ej";
export const UsageLimitText = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(usageLimitTextCss, props.className)} />;
});
const styledCodeFieldCss = "s1uz0vxe";
export const StyledCodeField = forwardRef((props, ref) => <TextField ref={ref} {...props} className={classNames(styledCodeFieldCss, props.className)} />);
const expirationDateContainerIsInlineCss = "e1rrxlcf";
const expirationDateContainerCss = "ehfaiou";
export const ExpirationDateContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    isInline,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(expirationDateContainerCss, {
    [expirationDateContainerIsInlineCss]: isInline
  }, props.className)} />;
});
const timeClockCircleIconContainerCss = "tcnntt3";
export const TimeClockCircleIconContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(timeClockCircleIconContainerCss, props.className)} />;
});
const expirationDateButtonHasErrorCss = "e18mbr9w";
const expirationDateButtonIsInlineCss = "e1ffnu6y";
const expirationDateButtonCss = "e1izdt82";
export const ExpirationDateButton = forwardRef((props, ref) => {
  const {
    hasError,
    isInline,
    ...restProps
  } = props;
  return <Button ref={ref} {...restProps} className={classNames(expirationDateButtonCss, {
    [expirationDateButtonIsInlineCss]: isInline,
    [expirationDateButtonHasErrorCss]: hasError
  }, props.className)} />;
});
const selectedDateTextCss = "s3c2gth";
export const SelectedDateText = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(selectedDateTextCss, props.className)} />;
});
const datePickerOverlayIsMobileCss = "d1rzqr2u";
const datePickerOverlayCss = "d19sleq8";
export const DatePickerOverlay = forwardRef((props, ref) => {
  const {
    isMobile,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(datePickerOverlayCss, {
    [datePickerOverlayIsMobileCss]: isMobile
  }, props.className)} />;
});
const timeSelectContainerIsInlineCss = "t17s3tsc";
const timeSelectContainerCss = "t1vtp9g3";
export const TimeSelectContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    isInline,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(timeSelectContainerCss, {
    [timeSelectContainerIsInlineCss]: isInline
  }, props.className)} />;
});
const styledBannerCss = "s1s4avcx";
export const StyledBanner = forwardRef((props, ref) => <Banner ref={ref} {...props} className={classNames(styledBannerCss, props.className)} />);
const discountTypeSwitcherDisabledCss = "d1r3su0a";
const discountTypeSwitcherCss = "d1wbqnew";
export const DiscountTypeSwitcherWrapper = forwardRef((props, ref) => {
  const {
    disabled = false,
    ...restProps
  } = props;
  return <div ref={ref} {...restProps} aria-disabled={disabled || undefined} className={classNames(discountTypeSwitcherCss, {
    [discountTypeSwitcherDisabledCss]: disabled
  }, props.className)} />;
});
const timeSelectFieldIsInlineCss = "t1v0pf9r";
const timeSelectFieldCss = "t6i6yf4";
export const TimeSelectField = forwardRef((props, ref) => {
  const {
    isInline,
    ...restProps
  } = props;
  return <SelectField ref={ref} {...restProps} className={classNames(timeSelectFieldCss, {
    [timeSelectFieldIsInlineCss]: isInline
  }, props.className)} />;
});
const optionsSectionCss = "ocsodin";
export const OptionsSection = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(optionsSectionCss, props.className)} />;
});
const footerIsMobileCss = "f1rsy4ml";
const footerCss = "fet0odt";
export const Footer = forwardRef((props, ref) => {
  const {
    isMobile,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(footerCss, {
    [footerIsMobileCss]: isMobile
  }, props.className)} />;
});
const inlineCardCss = "il25k3j";
export const InlineCouponCard = forwardRef((props, ref) => <div ref={ref} {...props} className={classNames(inlineCardCss, props.className)} />);
const inlineHeaderCss = "i1jyeiix";
export const InlineCouponHeader = forwardRef((props, ref) => <div ref={ref} {...props} className={classNames(inlineHeaderCss, props.className)} />);
const inlineHeaderTitleCss = "i1v2v4qt";
export const InlineCouponHeaderTitle = forwardRef((props, ref) => <div ref={ref} {...props} className={classNames(inlineHeaderTitleCss, props.className)} />);
const inlineDragHandleCss = "i13s8fzn";
export const InlineCouponDragHandle = forwardRef((props, ref) => <div ref={ref} {...props} className={classNames(inlineDragHandleCss, props.className)} />);
const inlineBodyCss = "i1fxovyk";
export const InlineCouponBody = forwardRef((props, ref) => <div ref={ref} {...props} className={classNames(inlineBodyCss, props.className)} />);
const inlineOptionRowCss = "iroq2kg";
export const InlineCouponOptionRow = forwardRef((props, ref) => <div ref={ref} {...props} className={classNames(inlineOptionRowCss, props.className)} />);
const inlineExpirationFieldsCss = "i1xfm7je";
export const InlineExpirationFields = forwardRef((props, ref) => <div ref={ref} {...props} className={classNames(inlineExpirationFieldsCss, props.className)} />);
const inlineFooterCss = "i1bx2439";
export const InlineCouponFooter = forwardRef((props, ref) => <div ref={ref} {...props} className={classNames(inlineFooterCss, props.className)} />);

require("./create_coupon_modal_styles.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./create_coupon_modal_styles.js");